module.exports = __webpack_public_path__ + "img/八达国瑞@2x.b65ad3bd.png";